import { UpgradeOption } from '@journeyapps-platform/types-charging-station';
import React from 'react';
import { ButtonType } from '../../../../widgets/buttons/ButtonWidget';
import { GroupedButtons } from '../../../../widgets/buttons/GroupedButtons';
import { FormLayoutWidget } from '../../../../widgets/layout/FormLayoutWidget';
import { styled } from '../../../../theme';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

export interface FinalConfirmationStepProps {
  upgrade: UpgradeOption;
  card_digits: string;
  back: () => any;
  proccess: () => any;
}

export const FinalConfirmationStep: React.FC<FinalConfirmationStepProps> = (props) => {
  return (
    <>
      <FormLayoutWidget
        sections={[
          {
            key: 'breakdown',
            elements: [
              <S.Container key="info">
                <S.BlobContainer>
                  <S.MetaContainer>
                    <S.MetaLabel>Plan</S.MetaLabel>
                    <S.MetaValue>{props.upgrade.external_label}</S.MetaValue>
                  </S.MetaContainer>
                  <S.MetaContainer>
                    <S.MetaLabel>Billed</S.MetaLabel>
                    <S.MetaValue>Monthly</S.MetaValue>
                  </S.MetaContainer>
                  <S.MetaContainer>
                    <S.MetaLabel>Card</S.MetaLabel>
                    <S.MetaValue>Ending with {props.card_digits}</S.MetaValue>
                  </S.MetaContainer>
                </S.BlobContainer>
                <S.BlobContainer>
                  <S.Row>
                    <S.RowKey>Plan fees</S.RowKey>
                    <S.RowValue>{formatter.format(props.upgrade.total_pm / 100)}</S.RowValue>
                  </S.Row>
                  <S.Row>
                    <S.RowKey>Tax</S.RowKey>
                    <S.RowValue>{formatter.format((props.upgrade.total_tax || 0) / 100)}</S.RowValue>
                  </S.Row>
                  <S.Hr />
                  <S.Row>
                    <S.RowKey>Total</S.RowKey>
                    <S.RowValue>
                      {formatter.format((props.upgrade.total_pm + (props.upgrade.total_tax || 0)) / 100)}
                    </S.RowValue>
                  </S.Row>
                </S.BlobContainer>
                <S.Terms>Billed immediately upon processing upgrade.</S.Terms>
                <S.Terms>
                  Additional overage (not included in total) is calculated and charged at the end of each billing cycle.
                </S.Terms>
              </S.Container>
            ]
          },
          {
            key: 'buttons',
            elements: [
              <GroupedButtons
                btns={[
                  {
                    type: ButtonType.SECONDARY,
                    label: 'Back',
                    action: () => {
                      props.back();
                    }
                  },

                  {
                    type: ButtonType.PRIMARY,
                    label: 'Process upgrade',
                    action: () => {
                      props.proccess();
                    }
                  }
                ]}
              />
            ]
          }
        ]}
      />
    </>
  );
};

namespace S {
  export const Terms = styled.div`
    color: ${(p) => p.theme.text.secondary};
    font-size: 13px;
    text-align: center;
    padding-top: 10px;
  `;

  export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `;

  export const Hr = styled.div`
    border-bottom: solid 1px ${(p) => p.theme.forms.ruler};
  `;

  export const RowKey = styled.div`
    color: ${(p) => p.theme.forms.ruler};
    font-size: 16px;
  `;

  export const RowValue = styled.div`
    color: ${(p) => p.theme.forms.input.color};
    font-size: 20px;
  `;

  export const Container = styled.div`
    width: 400px;
    align-self: center;
    margin: auto;
  `;

  export const BlobContainer = styled.div`
    border-radius: 15px;
    background: ${(p) => p.theme.forms.input.background};
    display: flex;
    padding: 20px;
    flex-direction: column;
    row-gap: 10px;
    margin-bottom: 5px;
  `;

  export const MetaContainer = styled.div``;

  export const MetaLabel = styled.div`
    font-size: 14px;
    color: ${(p) => p.theme.forms.ruler};
    padding-bottom: 5px;
  `;

  export const MetaValue = styled.div`
    font-size: 20px;
    color: ${(p) => p.theme.forms.input.color};
  `;
}
